var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9801 0C12.7645 0 12.5489 0.0824999 12.3847 0.246711L10.7005 1.93092L9.50973 3.12171L0 12.6316V16H3.36837L15.7531 3.61513C16.0823 3.28587 16.0823 2.75276 15.7531 2.42434L13.5755 0.246711C13.4112 0.0824999 13.1956 0 12.9801 0ZM12.9801 2.03289L13.9669 3.01974L12.8781 4.10855L11.8913 3.12171L12.9801 2.03289ZM10.7005 4.3125L11.6873 5.29934L2.67101 14.3158H1.68419V13.3289L10.7005 4.3125Z",
    fill: "#A1A9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.75efa85b.svg";
export { ForwardRef as ReactComponent };